import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { ModalCustom } from "components/ModalCustom";
import { ModalButton } from "components/ModalCustom/style";
import {
  AlertBox,
  FooterActions,
  InfoItem,
  InfoRow,
  Pergunta,
  SucessoBox,
} from "./style";

interface IProps {
  show: boolean;
  quantidade: number;
  possuiDebitosAdicionais: boolean;
  sucesso: boolean;
  loading: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalConfirmarPagamento({
  show,
  quantidade,
  possuiDebitosAdicionais,
  sucesso,
  loading,
  handleClose,
  onConfirm,
}: IProps) {
  const count = String(quantidade).padStart(2, "0");

  if (sucesso) {
    return (
      <ModalCustom
        show={show}
        handleClose={handleClose}
        title="Pagar débitos"
        centered
      >
        <SucessoBox>
          <FontAwesomeIcon icon={faCheck} />
          <span>
            Solicitação efetuada com sucesso, os pagamentos serão processados.
          </span>
        </SucessoBox>
      </ModalCustom>
    );
  }

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Pagar débitos"
      centered
      footer
      footerTools={
        <FooterActions>
          <ModalButton
            outline
            variante="primary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </ModalButton>
          <ModalButton onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Processando...
              </>
            ) : (
              "Confirmar pagamento"
            )}
          </ModalButton>
        </FooterActions>
      }
    >
      <AlertBox>
        <FontAwesomeIcon icon={faCircleExclamation} />
        {possuiDebitosAdicionais
          ? "Além da taxa de transferência, foram encontrados outros débitos vinculados ao(s) processo(s) selecionado(s)."
          : "Confira as informações abaixo antes de confirmar o pagamento."}
      </AlertBox>
      <InfoRow>
        <InfoItem>
          <small>Processos selecionados</small>
          <strong>{count}</strong>
        </InfoItem>
      </InfoRow>
      <Pergunta>
        {possuiDebitosAdicionais
          ? "Deseja prosseguir com o pagamento de todos os débitos?"
          : "Deseja confirmar o pagamento dos débitos selecionados?"}
      </Pergunta>
    </ModalCustom>
  );
}
